import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import GetAppSharpIcon from '@material-ui/icons/GetAppSharp';

import downloadFiles from '../../utils/downloadFiles';
import { formatDate, formatMoney, formatFractionWithMask } from '../../utils/formatter';

import SnackbarComponent from '../../components/Snackbar';
import TableWithSorting from '../../components/TableWithSorting';

import { portfolioComposition } from '../../redux-flow/containers/PortfolioCompositionTable/portfolioComposition/index';
import { exportPortfolio, exportPortfolioReset } from '../../redux-flow/containers/PortfolioCompositionTable/exportPortfolio/index';

import useStyles from './style';

const columns = [
  {
    id: 'category',
    label: 'Categoria',
    minWidth: 100,
    align: 'left',
    format: value => value,
  },
  {
    id: 'ticker',
    label: 'Código/Ticker',
    minWidth: 150,
    align: 'left',
    format: value => value,
  },
  {
    id: 'isin',
    label: 'ISIN',
    minWidth: 170,
    align: 'left',
    format: value => ((value === null || value === undefined) ? '-' : value),
  },
  {
    id: 'quantityDisplay',
    label: 'Quantidade',
    minWidth: 80,
    align: 'left',
    format: value => formatFractionWithMask(value, 2),
  },
  {
    id: 'priceDisplay',
    label: 'Preço',
    minWidth: 80,
    align: 'left',
    format: value => formatMoney(value),
  },
  {
    id: 'valueDisplay',
    label: 'Valor',
    minWidth: 80,
    align: 'left',
    format: value => formatMoney(value),
  },
  {
    id: 'proportionDisplay',
    label: 'Peso (%)',
    minWidth: 80,
    align: 'left',
    format: value => value,
  },
];

const PortfolioCompositionTableSorting = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [portfolioData, setPortfolioData] = useState([]);
  const { exportPortfolioReducer, portfolioCompositionReducer } = useSelector(state => state);
  const { ticker } = useRouteMatch().params;

  useEffect(() => {
    dispatch(portfolioComposition(ticker));
  }, []);

  useEffect(() => {
    if (exportPortfolioReducer.data.size > 0) downloadFiles(exportPortfolioReducer.data, 'export-portfolio.xlsx');
  }, [exportPortfolioReducer.data]);

  useEffect(() => {
    if (portfolioCompositionReducer.data.portfolios) {
      setPortfolioData(portfolioCompositionReducer.data.portfolios[0].assets);
    }
  }, [portfolioCompositionReducer.data.portfolios]);

  return (
    <>
      <SnackbarComponent
        msg="Carregando..."
        openProps={portfolioCompositionReducer.loading || exportPortfolioReducer.loading}
        variant="info"
      />
      <SnackbarComponent
        msg="Erro ao realizar a solicitação"
        openProps={exportPortfolioReducer.data === false}
        variant="error"
        callback={() => dispatch(exportPortfolioReset())}
      />
      <TableWithSorting
        columns={columns}
        rows={portfolioData}
        title={(portfolioCompositionReducer.data.portfolios
                && portfolioCompositionReducer.data.portfolios.length > 0)
                && `Composição da carteira - ${formatDate(portfolioCompositionReducer.data.portfolios[0].date)}`}
      />
      <Button
        variant="outlined"
        color="primary"
        onClick={() => dispatch(exportPortfolio(ticker))}
        type="button"
        className={classes.button}
      >
        <GetAppSharpIcon className={classes.buttonIcon} />
        baixar carteira consolidada
      </Button>
    </>
  );
};

export default PortfolioCompositionTableSorting;
